import { PlanTier, FeatureKey } from '../types/entitlements'
export const upsellCopy = {
  lockedFeature: (plan: PlanTier, feature: string) =>
    `Available on ${plan}: unlock ${feature} to accelerate growth`,
  limitNear: 'You are near the Free limit',
  limitReached: (resource: string) => `You have reached your ${resource} limit`,
  plansShort: {
    Growth:
      'More Programs and Playbooks, ABM segments, event triggers, advanced export',
    Scale: 'Unlimited Plays, Copilot tasking, partner and field modeling, API',
    Enterprise: 'SSO, governed prompts, audit logs, priority support',
  },
  plansDetailed: {
    Growth: {
      title: 'Scale Your GTM Programs',
      benefits: [
        'Create up to 5 Programs',
        'Unlimited Playbooks',
        'Add up to 50 Plays',
        'ABM Segments & Event Triggers',
        'Advanced Reporting & Export',
      ],
    },
    Scale: {
      title: 'Unlock AI-Powered Automation',
      benefits: [
        'Unlimited Programs & Plays',
        'Copilot Task Automation',
        'Partner & Field Motion Modeling',
        'API Access',
        'Priority Support',
      ],
    },
    Enterprise: {
      title: 'Enterprise-Grade Security & Control',
      benefits: [
        'Everything in Scale',
        'SSO & SAML Authentication',
        'Governed Prompts',
        'Audit Logs & Compliance',
        'Dedicated Customer Success Manager',
      ],
    },
  },
  ctas: {
    upgrade: 'Upgrade',
    comparePlans: 'Compare Plans',
    talkToSales: 'Talk to Sales',
    continue: 'Continue',
    seePlan: 'See Plan',
    preview: 'Preview',
    exportBasic: 'Export Basic',
    upgradeToExport: 'Upgrade to Export Advanced',
  },
  roiSnippets: {
    'programs.create': 'Add more Programs to model new GTM motions',
    'playbooks.create': 'Create unlimited Playbooks to organize your plays',
    'plays.create': 'Add more Plays to your automation library',
    'segments.abm': 'Target high-value accounts with ABM segments',
    'triggers.event': 'Automate plays with event-based triggers',
    'forecast.bandit': 'Run bandit tests to auto-allocate to winners',
    'forecast.export_advanced': 'Export detailed forecasts with custom formats',
    'copilot.tasks': 'Enable Copilot tasks to reduce time to next stage',
    'api.access': 'Integrate with your tech stack via API',
    sso: 'Simplify access with enterprise SSO',
    'governance.audit': 'Track all changes with audit logs',
    'partner.modeling': 'Model partner-sourced pipeline',
    'field.modeling': 'Forecast field event impact',
  },
  featureNames: {
    'programs.create': 'Program Creation',
    'playbooks.create': 'Playbook Creation',
    'plays.create': 'Play Creation',
    'segments.abm': 'ABM Segments',
    'triggers.event': 'Event Triggers',
    'forecast.bandit': 'Bandit Testing',
    'forecast.export_advanced': 'Advanced Export',
    'copilot.tasks': 'Copilot Tasks',
    'api.access': 'API Access',
    sso: 'SSO Authentication',
    'governance.audit': 'Audit Logs',
    'partner.modeling': 'Partner Modeling',
    'field.modeling': 'Field Modeling',
  },
}
export function trackUpsellEvent(event: string, data: Record<string, any>) {
  // In production, send to analytics service
  console.log('Upsell Analytics:', event, data)
}
